import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { CompanyRegistrationService }  from '../../_services/company-registration.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  public registration_form: any;
  pwdBoxHide1 = true;
  pwdBoxHide2 = true;

  constructor(
    private titleService: Title,
    public companyRegistrationService: CompanyRegistrationService,
    private loading : LoadingService,
    private router:Router,
    private authService: AuthService,
    private notificationService: NotificationService,) { }

  ngOnInit() {
    this.titleService.setTitle('Property Registration !!');
  }


  onRegistrationFormSubmit(formData: any)
  {
    if (this.companyRegistrationService.registration_form.valid)
    {
      //console.log(formData);
      this.loading.spin$.next(true);
      if(this.companyRegistrationService.registration_form.value.password == 
        this.companyRegistrationService.registration_form.value.confirm_password)
      {
        this.companyRegistrationService.insert_registration_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            localStorage.setItem('dschool_id_token', data['access_token']);
            localStorage.setItem('user_role', data['user']['role']);
            this.authService.user_dept = localStorage.getItem('user_role');
            this.companyRegistrationService.registration_form.reset();
            this.loading.spin$.next(false);
            this.router.navigateByUrl('/company/property');
          } 
          else 
          {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else
      {
        this.notificationService.error('Password and Confirm password are must be same!!');
        this.loading.spin$.next(false);
      }  
    } 
  }


}
